export const cancelSportsnewListFlight = (flight) => {
  if (!flight || flight.cancelled) return false;

  flight.cancelled = true;
  flight.abortController?.abort?.();

  const retryWait = flight.retryWait;
  if (retryWait) {
    clearTimeout(retryWait.timer);
    flight.retryWait = null;
    retryWait.resolve(false);
  }
  return true;
};

export const cancelSportsnewListFlights = (flights) => {
  if (!(flights instanceof Map)) return 0;
  let cancelled = 0;
  flights.forEach((flight) => {
    if (cancelSportsnewListFlight(flight)) cancelled += 1;
  });
  flights.clear();
  return cancelled;
};

/**
 * A membership event must be followed by a request that started after that
 * event. Waiting for an older same-key flight is fine, but its response cannot
 * itself satisfy the refresh.
 */
export const continueSportsnewListRefreshAfterFlight = async (flight, startFresh) => {
  try {
    await flight?.promise;
  } catch {
    // A failed pre-event request still has to be followed by the fresh one.
  }
  return typeof startFresh === 'function' ? startFresh() : undefined;
};
